<template>
    <v-tooltip top>
        <template v-slot:activator="{on}">
            <v-card v-show="show" class="player-card ml-1" :class="color" depressed flat tile v-on="on">
                {{type}}
            </v-card>
        </template>
        <span>{{tooltip}}</span>
    </v-tooltip>
</template>

<script>
    export default {
        name: 'PlayerCard',
        props: ['type', 'color', 'tooltip', 'show'],
    }
</script>

<style>
    .v-card.player-card {
        min-width: 15px;
        width: 15px;
        height: 26px;
        line-height: 26px;
        color: #000000;
        font-size: 12px;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        text-align: center;
    }
</style>